module.exports = __webpack_public_path__ + "img/cd8e8cf.svg";